import React from 'react';
import { Tabs, Tab, withStyles } from '@material-ui/core';
import { navigate } from 'gatsby';
import { Location } from '@reach/router';
import { getProductNameFromUrlString } from '../../utils/url';
import PropTypes from 'prop-types';

const StyledTabs = withStyles({
    textColor: 'inherit',
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        marginBottom: '10px',
        '& > div': {
            backgroundColor: 'white',
            width: '123px',
            marginBottom: '0px',
        },
    },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles({
    root: {
        fontSize: '15px',
        textTransform: 'none',
        letterSpacing: '0.5px',
        '&:active': {
            fontWeight: 'bold',
        },
        '&:focus': {
            fontWeight: 'bold',
        },
    },
    selected: {
        fontWeight: 'bold',
    },
    textColorInherit: {
        opacity: 1,
        color: '#FFFFFF',
    },
})((props) => <Tab {...props} />);

class ProductSelector extends React.Component {
    constructor(props) {
        super(props);
        this.router = ['/media-shuttle/', '/jet/', '/manager-agents/', '/flight/'];
        this.products = ['Media Shuttle', 'Jet', 'Manager+Agents', 'Flight'];
        this.state = {
            selectedTab: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.getCurrentTab = this.getCurrentTab.bind(this);
        this.updateTab = this.updateTab.bind(this);
    }

    handleChange(event, selectedTab) {
        this.setState({ selectedTab });
        navigate(this.router[selectedTab]);
    }

    componentDidUpdate() {
        this.updateTab();
    }

    componentDidMount() {
        this.updateTab();
    }

    updateTab() {
        const selectedTab = this.getCurrentTab(this.props.location.href);
        if (this.state.selectedTab !== selectedTab) {
            this.setState({ selectedTab });
        }
    }

    getCurrentTab(currentUrl) {
        const withSlashes = `/${getProductNameFromUrlString(currentUrl, false)}/`;
        const selectedTab = this.router.indexOf(withSlashes);
        if (selectedTab === -1) {
            return false;
        }
        return selectedTab;
    }

    render() {
        return (
            <StyledTabs onChange={this.handleChange} value={this.state.selectedTab} style={{ marginTop: '30px' }}>
                {this.products.map((product, index) => (
                    <StyledTab key={index} label={product} />
                ))}
            </StyledTabs>
        );
    }
}

export default (props) => (
    <Location>{(locationProps) => <ProductSelector {...locationProps} {...props}></ProductSelector>}</Location>
);

ProductSelector.propTypes = {
    classes: PropTypes.object.isRequired,
};
